import React from "react";
import CurrencyFormat from "react-currency-format";
import {useHistory } from "react-router-dom";
import { useStateValue } from "../StateProvider";
import "./subtotal.scss";

const SubTotal = () => {
  const getCartTotal = (basket) =>
    basket?.reduce((amount, item) => item.price + amount, 0);

    const history = useHistory();
  const [{ basket },] = useStateValue();

  return (
    <div className=" subtotal my-4">
      <CurrencyFormat
        renderText={(value) => (
          <p>
            Subtotal({basket.length} items ): <strong>{`${value}`}</strong>
          </p>
        )}
        decimalScale={2}
        value={getCartTotal(basket)}
        displayType={"text"}
        thousandSeparator={true}
        prefix={"$"}
      />

      {/* <Link to="/"> */}
        <button className="checkOut_btn" onClick={e => history.push('/payment')}>Proceed to checkout</button>
      {/* </Link> */}
    </div>
  );
};

export default SubTotal;
